import React from "react";

const DocumentsAlerts = () => {
  return (
    <div>
      <h1>Documents & Alerts</h1>
      <p>Upload, manage, and set alerts for important documents.</p>
    </div>
  );
};

export default DocumentsAlerts;
